import { useRef, useState } from 'react';
import { useDismissOnOutsideClick } from '../../hooks/useDismissOnOutsideClick';
import { ResourceReportModal } from './ResourceReportModal';
import { TagReportModal } from './TagReportModal';
import type { BulkContext } from '../AddTagControl';

/**
 * Reports dropdown — the React port of the resource_filter toolbar's Download Reports
 * menu (Resource Report / Tag Report). Reports run over the current view (collections +
 * filter), so unlike Add Tag / Batches this doesn't depend on the row selection.
 */
export function ReportsButton({ bulk }: { bulk: BulkContext }) {
  const [menu, setMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useDismissOnOutsideClick(menuRef, menu, () => setMenu(false));
  const [modal, setModal] = useState<null | 'resource' | 'tag'>(null);

  return (
    <>
      <div className="btn-group" ref={menuRef}>
        <button
          type="button"
          className="btn btn-default dropdown-toggle"
          title="Download Reports"
          data-testid="reports-menu-btn"
          onClick={() => setMenu((v) => !v)}
        >
          <i className="fas fa-download" /> <span className="caret" />
        </button>
        {menu && (
          <ul className="dropdown-menu" style={{ display: 'block' }} data-testid="reports-menu">
            <li>
              <a href="#" data-testid="reports-resource-menu-item" onMouseDown={(e) => { e.preventDefault(); setModal('resource'); setMenu(false); }}>
                <i className="far fa-file-excel fa-fw" /> Resource Report
              </a>
            </li>
            <li>
              <a href="#" data-testid="reports-tag-menu-item" onMouseDown={(e) => { e.preventDefault(); setModal('tag'); setMenu(false); }}>
                <i className="far fa-file-excel fa-fw" /> Tag Report
              </a>
            </li>
          </ul>
        )}
      </div>
      {modal === 'resource' && <ResourceReportModal bulk={bulk} onClose={() => setModal(null)} />}
      {modal === 'tag' && <TagReportModal bulk={bulk} onClose={() => setModal(null)} />}
    </>
  );
}
